<div class="col-12">
    <div class="row jcc">
        <img class="img-xsm" src="../../../assets/images/level/{{level}}.png">
    </div>
</div>
<div class="col-12 text-center"  >
   <span class="f-bold" [ngClass]="colorClass">{{text}}</span>
</div>